import { useMemo, useCallback } from "react";
import { OverlayTrigger, Dropdown } from "react-bootstrap";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import { TooltipStandard } from "../../../Utility/TooltipStandard";

// import DeliveryMenuSelect from "../../DeliveryMenuSelect";
import { useOrderStatus } from "../services";

import {
  canFileClaim,
  canModify,
  canRequestReturn,
  canVoid,
} from "../../../../helpers/orderActionsUtilities";
import { openInNewTab } from "../../../../helpers/utilities";

import {
  clientsToBeExcludedFromPrintingLabels,
  // orderHistoryPreFilters,
  localStorageVariables,
  pages,
} from "../../../../constants";
import { basePath } from "../../../../config";

import { checkIfClient } from "../constants";

const constantFns = {
  modify: (event) => {
    const { deliveryId } = event.target.dataset;

    localStorage.setItem(localStorageVariables.lastModifying, deliveryId);

    openInNewTab(`${basePath}/modify-order/${deliveryId}`);
  },
  returnRequest: (event) => {
    const { deliveryId } = event.target.dataset;

    openInNewTab(`${basePath}/ActionCenter/Return/${deliveryId}`);
  },
  newDeliveryConcern: (event) => {
    const { deliveryId } = event.target.dataset;

    openInNewTab(`${basePath}/ActionCenter/DeliveryConcern/${deliveryId}`);
  },
  viewDeliveryConcern: (event) => {
    const { concernIncidentNo } = event.target.dataset;
    openInNewTab(`${basePath}${pages.viewConcern.url}/${concernIncidentNo}`);
  },

  newPostClaimConcern: (event) => {
    const { deliveryId } = event.target.dataset;

    // history.push(`/post-claim/${deliveryId}`);
    // history.push(`/ActionCenter/Claim/${deliveryId}`);
    openInNewTab(`${basePath}/ActionCenter/Claim/${deliveryId}`);
  },

  viewClaimConcern: (event) => {
    const { claimId } = event.target.dataset;
    openInNewTab(`${basePath}${pages.viewClaim.url}/${claimId}`);
  },
};

function PendingOrderStatus({
  isLoading,
  children,
  dontShowLoading,
  isCustomerOption,
}) {
  if (isLoading && !dontShowLoading && !isCustomerOption)
    return <DropdownItem disabled>Loading...</DropdownItem>;

  if (isLoading && !dontShowLoading && isCustomerOption)
    return (
      <button type="button" disabled className="btn btn-primary w-100">
        Loading...
      </button>
    );

  return children;
}

function DeliveryMenuSelect({
  deliveryId,
  linkId,
  invoiceNumber,
  creationDate,
  //   deliveryDate,
  // deliveryStatus,
  deliveryType,
  //   buyoutOrReturn,
  //   returnDeliveryId,
  concernIncidentNo,
  claimID,
  clientDoesNotAllowCustomerReturns,
  returnRequestStatuses,
  decodedToken,

  // Functions
  onPrintLabelClick,
  onVoidClick,
}) {
  const { data: order } = useOrderStatus(deliveryId);

  const deliveryStatus = order?.status;

  const isClient = useMemo(() => checkIfClient(decodedToken), [decodedToken]);
  const isStatusLoading = !(deliveryStatus && deliveryStatus !== "");

  const renderCustomerMenuOptions = useCallback(() => {
    if (deliveryType === "Return") {
      return (
        <button
          type="button"
          // style={customerButtonStyle}
          onClick={onPrintLabelClick}
          className="btn btn-primary w-100"
          data-delivery-id={deliveryId}
        >
          Print Label
        </button>
      );
    }

    if (deliveryType !== "Regular") return null;

    return (
      <PendingOrderStatus isLoading={isStatusLoading} isCustomerOption>
        {(() => {
          if (deliveryStatus === null || deliveryStatus === "") {
            return null;
          }

          if (deliveryStatus === "Open") {
            return (
              <OverlayTrigger
                flip
                placement="top"
                overlay={
                  <TooltipStandard>
                    Returns cannot be placed until the order has been picked up.
                  </TooltipStandard>
                }
              >
                <button
                  type="button"
                  style={{
                    fontSize: ".9rem",
                  }}
                  className="btn btn-primary disabled w-100"
                  data-delivery-id={deliveryId}
                >
                  Return
                </button>
              </OverlayTrigger>
            );
          }

          if (clientDoesNotAllowCustomerReturns) {
            return (
              <OverlayTrigger
                flip
                placement="top"
                overlay={
                  <TooltipStandard>
                    Unable to start a return.
                    <br /> Please contact Dealer to initiate a return for this
                    order.
                  </TooltipStandard>
                }
              >
                <button
                  type="button"
                  style={{
                    fontSize: ".9rem",
                  }}
                  data-delivery-id={deliveryId}
                  className="btn btn-primary disabled w-100"
                >
                  Return
                </button>
              </OverlayTrigger>
            );
          }

          if (returnRequestStatuses?.isReturnRequestedPending) {
            return (
              <button
                type="button"
                style={{
                  fontSize: ".9rem",
                }}
                disabled
                className="btn btn-primary w-100"
              >
                Return Pending
              </button>
            );
          }

          return (
            <button
              type="button"
              style={{
                fontSize: ".9rem",
              }}
              className="btn btn-primary w-100"
              data-delivery-id={deliveryId}
              // onClick={onReturnRequestClick}
              onClick={constantFns.returnRequest}
            >
              Return
            </button>
          );
        })()}
      </PendingOrderStatus>
    );
  }, [
    deliveryType,
    isStatusLoading,
    onPrintLabelClick,
    deliveryId,
    deliveryStatus,
    clientDoesNotAllowCustomerReturns,
    returnRequestStatuses?.isReturnRequestedPending,
  ]);

  if (isClient) {
    return (
      <Dropdown align="end" drop="down">
        <Dropdown.Toggle id="dropdown-client-button">&#8942;</Dropdown.Toggle>

        <Dropdown.Menu
          popperConfig={{
            strategy: "fixed",
            modifiers: [
              { name: "preventOverflow", options: { boundary: "viewport" } },
            ],
          }}
        >
          {!clientsToBeExcludedFromPrintingLabels.includes(
            decodedToken.ClientId,
          ) && (
            <Dropdown.Item
              data-delivery-id={deliveryId}
              onClick={onPrintLabelClick}
            >
              Print Label
            </Dropdown.Item>
          )}

          {concernIncidentNo ? (
            <Dropdown.Item
              // disabled
              // data-delivery-id={deliveryId}
              // data-invoice-number={invoiceNumber}
              // data-creation-date={creationDate}
              data-concern-incident-no={concernIncidentNo}
              // onClick={handleClickViewConcern}
              onClick={constantFns.viewDeliveryConcern}
            >
              View Existing Concern
            </Dropdown.Item>
          ) : (
            <Dropdown.Item
              data-delivery-id={deliveryId}
              data-invoice-number={invoiceNumber}
              data-creation-date={creationDate}
              // onClick={onDeliveryConcernRequestClick}
              onClick={constantFns.newDeliveryConcern}
            >
              New Delivery Concern
            </Dropdown.Item>
          )}

          {claimID ? (
            <Dropdown.Item
              data-claim-id={claimID}
              // onClick={handleClickViewClaim}
              onClick={constantFns.viewClaimConcern}
            >
              View Existing Claim
            </Dropdown.Item>
          ) : null}

          <PendingOrderStatus isLoading={isStatusLoading}>
            {canModify(deliveryStatus, creationDate, deliveryType).ableTo && (
              <Dropdown.Item
                data-delivery-id={deliveryId}
                data-link-id={linkId}
                onClick={constantFns.modify}
              >
                Modify
              </Dropdown.Item>
            )}

            {canVoid(deliveryStatus, creationDate, deliveryType).ableTo && (
              <Dropdown.Item
                data-delivery-id={deliveryId}
                onClick={onVoidClick}
              >
                Void
              </Dropdown.Item>
            )}

            {canRequestReturn(deliveryStatus, deliveryType).ableTo &&
              (returnRequestStatuses?.isReturnRequestedPending ? (
                <Dropdown.Item data-delivery-id={deliveryId} disabled>
                  Return Request Pending
                </Dropdown.Item>
              ) : (
                <Dropdown.Item
                  data-delivery-id={deliveryId}
                  onClick={constantFns.returnRequest}
                >
                  Return
                </Dropdown.Item>
              ))}

            {claimID === 0 && canFileClaim(deliveryStatus, claimID).ableTo && (
              <Dropdown.Item
                data-delivery-id={deliveryId}
                // onClick={onPostClaimClick}
                onClick={constantFns.newPostClaimConcern}
              >
                New Claim
              </Dropdown.Item>
            )}
          </PendingOrderStatus>
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  return renderCustomerMenuOptions();
}

export default DeliveryMenuSelect;
